"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableGrid = exports.DEFAULT_PAGE_SIZE = exports.ItemTypes = void 0;
const react_1 = __importStar(require("react"));
const react_collapse_1 = require("react-collapse");
const classnames_1 = __importDefault(require("classnames"));
const pagination_1 = require("../pagination");
const icons_1 = require("../icons");
require("./styles.scss");
var ItemTypes;
(function (ItemTypes) {
    ItemTypes["String"] = "string";
    ItemTypes["Number"] = "number";
})(ItemTypes = exports.ItemTypes || (exports.ItemTypes = {}));
exports.DEFAULT_PAGE_SIZE = 5;
const ExpandableGrid = (props) => {
    const { data, pageSize = exports.DEFAULT_PAGE_SIZE, columns, getDataId, expandableContent, defaultSorting, preselectedIds = [], permanentExpandedIds = [], isSingleExpandedItem, isExpandContentFixed, noDataMessage, totalRows, onPageChange, minWidth, } = props;
    const dataSourceCopy = [...data];
    const [activeRowKeys, setActiveRowKeys] = (0, react_1.useState)(preselectedIds);
    const [sorting, setSorting] = (0, react_1.useState)();
    const hasPages = totalRows > pageSize;
    const [page, setPage] = (0, react_1.useState)(1);
    const containerRef = (0, react_1.useRef)(null);
    const setPageHandler = (page) => {
        setPage(page);
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page);
        setActiveRowKeys([]);
    };
    const gridTemplate = columns.map(({ size }) => `minmax(0, ${isNaN(+size) ? size : size + "fr"})`).join(" ");
    const createExpandedRowToggleHandler = (id) => () => activeRowKeys.includes(id.toString())
        ? setActiveRowKeys(activeRowKeys.filter((key) => key !== id.toString()))
        : setActiveRowKeys(isSingleExpandedItem ? [id.toString()] : [...activeRowKeys, id.toString()]);
    const sortingConfig = sorting || defaultSorting;
    if (sortingConfig) {
        const headerItem = columns.find(({ id }) => sortingConfig.columnId === id);
        if (headerItem && headerItem.compare) {
            dataSourceCopy.sort((left, right) => { var _a; return ((_a = headerItem.compare) === null || _a === void 0 ? void 0 : _a.call(headerItem, left, right, sortingConfig.type)) || 0; });
        }
    }
    const setSortingHandler = (columnId) => {
        const sortingConfig = Object.assign({ columnId, type: "desc" }, (sorting || defaultSorting));
        setActiveRowKeys([]);
        if (sortingConfig.columnId === columnId) {
            setSorting({ columnId, type: sortingConfig.type === "desc" ? "asc" : "desc" });
        }
        else {
            setSorting({ columnId, type: "desc" });
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (preselectedIds.length > 0) {
            (_a = document
                .querySelector("#row-id" + preselectedIds[0].toLowerCase())) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [preselectedIds]);
    return (react_1.default.createElement("div", { ref: containerRef, className: "c-expandable-grid" },
        react_1.default.createElement("div", { className: "c-expandable-grid__content-container" },
            react_1.default.createElement("div", { className: "c-expandable-grid__content", style: { minWidth } },
                react_1.default.createElement("div", { className: "c-expandable-grid__header", style: { gridTemplateColumns: gridTemplate } }, columns.map((header) => {
                    const headerCellClassName = (0, classnames_1.default)("c-expandable-grid__header-cell", {
                        ["c-expandable-grid__header-cell--" + header.type]: header.type,
                        "c-expandable-grid__header-cell--sortable": header.isSortable,
                    }, header.className);
                    let sortingArrows = null;
                    if (header.isSortable) {
                        sortingArrows = (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(icons_1.SortArrowUpIcon, { scale: 0.8, color: "gray" }),
                            react_1.default.createElement(icons_1.SortArrowDownIcon, { scale: 0.8, color: "gray" })));
                    }
                    if ((sortingConfig === null || sortingConfig === void 0 ? void 0 : sortingConfig.columnId) === header.id) {
                        if (sortingConfig.type === "asc") {
                            sortingArrows = react_1.default.createElement(icons_1.SortArrowUpIcon, { scale: 0.8, color: "red" });
                        }
                        else {
                            sortingArrows = react_1.default.createElement(icons_1.SortArrowDownIcon, { scale: 0.8, color: "red" });
                        }
                    }
                    return (react_1.default.createElement("div", { onClick: () => header.isSortable && setSortingHandler(header.id), key: header.id, className: headerCellClassName },
                        header.title,
                        header.isSortable && react_1.default.createElement("div", { className: "c-expandable-grid__header-cell-sorting" }, sortingArrows)));
                })),
                react_1.default.createElement("div", { className: "c-expandable-grid__body" },
                    dataSourceCopy.map((item) => {
                        const rowId = getDataId(item);
                        const isPermanentExpanded = permanentExpandedIds.includes(rowId.toString());
                        const isExpanded = isPermanentExpanded || activeRowKeys.includes(rowId.toString());
                        const state = {
                            isExpanded,
                            isPermanentExpanded,
                            expandToggle: createExpandedRowToggleHandler(rowId),
                        };
                        return (react_1.default.createElement("div", { id: "row-id" + rowId.toString().toLowerCase(), key: rowId, className: "c-expandable-grid__body-row-container" },
                            react_1.default.createElement("div", { style: { gridTemplateColumns: gridTemplate }, className: "c-expandable-grid__body-row" }, columns.map((cell, index) => {
                                const headerCellClassName = (0, classnames_1.default)("c-expandable-grid__body-cell", {
                                    ["c-expandable-grid__body-cell--" + cell.type]: cell.type,
                                }, cell.className);
                                return (react_1.default.createElement("div", { key: cell.id + index, className: headerCellClassName }, cell.render(item, state)));
                            })),
                            expandableContent && (react_1.default.createElement(react_collapse_1.UnmountClosed, { isOpened: isExpandContentFixed || isPermanentExpanded || isExpanded }, expandableContent(item)))));
                    }),
                    totalRows === 0 && (react_1.default.createElement("div", { className: "c-expandable-grid__empty" }, noDataMessage !== null && noDataMessage !== void 0 ? noDataMessage : "There are no data yet"))))),
        hasPages && (react_1.default.createElement("div", { className: "c-expandable-grid__pagination" },
            react_1.default.createElement(pagination_1.Pagination, { visible: 3, current: page, amount: Math.ceil(totalRows / pageSize), selectPage: setPageHandler })))));
};
exports.ExpandableGrid = ExpandableGrid;
exports.default = ExpandableGrid;
